import { render, staticRenderFns } from "./OtherItemsTable.vue?vue&type=template&id=086f0b2f&scoped=true&"
import script from "./OtherItemsTable.vue?vue&type=script&lang=ts&"
export * from "./OtherItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./OtherItemsTable.vue?vue&type=style&index=0&id=086f0b2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f0b2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VSimpleTable,VTooltip})
